var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"grey--text text-caption text-decoration-none",attrs:{"to":_vm.to}},[_c('v-icon',{attrs:{"small":""},domProps:{"textContent":_vm._s(_vm.icons.back)}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }